/*

  Creek: Initialize, with modules.

  TODO:

  - Replace jQuery, Moment.js, and FontAwesome with smaller things.
  - Replace SM2 Bar UI with a custom audio player (Vue component).
  - Use "Creek.config" for config and "Creek.data" for API data.

*/ 

/* ------------------------------------
  Create the global Creek object.
*/

/// !!! This should not be a dependency. Replace with smaller things.
window.$ = require('jquery');
window.jQuery = window.$;

//Only create if it doesn't exist
if(typeof window.Creek == "undefined"){
  console.log("Creek: Creating Creek object.");
  window.Creek = {};
}

//Add placeholder config property if it doesn't exist
if(typeof Creek.config == "undefined"){
  Creek.config = {};
}

//Version string
Creek.version = "0.7.9";

//Initial settings
Creek.data = require('./creek-data').init(Creek.config);

//Initial debug message output, based on settings
Creek.debug = require('./creek-debug').init(Creek.data);

//Random utilities
Creek.util = require('./creek-util');

/* ------------------------------------

  Vue: Re-use Vue if it's already included on the page.

  - Requires Vue 2.

  TODO:

  - Detect Vue 2.
  - Documentation for how to use this.

  Note: Uses Vue 2 only. Why? 
  - They should upgrade from Vue 1 anyway.
  - There aren't many radio websites using it already, so 
    Creek is probably their first time seeing Vue
    (so they're starting out with 2.x).

*/

if(typeof window.Vue == "undefined"){
  console.log("Creating new Vue.js instance.")
  // Creek.debug.log("Creating new Vue.js instance.")
  window.Vue = require('vue');
  window.VueRouter = require('vue-router');
}
else {
  console.log("Using existing Vue.js instance.")
  // Creek.debug.log("Using existing Vue.js instance.")
}

//Turn on Debug.
// !!!TODO: Is this valid for Vue 2?
window.Vue.config.debug = true;

// !!! FORCE DEBUG
// !!! FORCE DEBUG
// !!! FORCE DEBUG
// !!! FORCE DEBUG
Creek.config.debug = true;

/* ---------------------------------------
  Vue: Add Creek's global Vue Components
*/

var CreekShowsComponents = require('./creek-shows-components');

//Add all of the components to the main Vue instance
for (csc in CreekShowsComponents) {
  console.log("Vue: Creating component: "+csc);
  // Creek.debug.log("Vue: Creating component: "+csc);
  window.Vue.component(csc, CreekShowsComponents[csc]);
}

/* ------------------------------------
 Include main CSS for Creek elements
*/

var CreekMainCSS = require('./css/creek.css');

/* ------------------------------------
 Include CSS libraries
*/

//FontAwesome
//
// !!! TODO: DON'T USE FONTAWESOME!
//     This should be replaced with individual icons.
//
// Modified CSS to have absolute URLs 
var css_fontawesome = require('./css/font-awesome.css');

//SM2 Bar UI
//
// !!! TODO: DON'T USE SM2 BAR UI!
//
// Modified CSS to have absolute URLs
var css_sm2_bar_ui = require('../lib/sm2/bar-ui/css/bar-ui.css');

/* ------------------------------------

  Main Creek init.

  Builds the other tools.

*/
window.Creek.init = function(config){

  //Update Creek config with setings from instantiation
  Creek.data = require('./creek-data').init(config);

  //Add debug again
  Creek.debug = require('./creek-debug').init(config);

  Creek.debug.log("Initializing.");

  /* ---------------------------------------
    Vue: Add Creek's routes
  */

  if(Creek.data.router.enable){
    Creek.debug.log("Router: Enabled");
    Creek.showsRouter = require('./creek-shows-router');
  }

  /* ---------------------------------------
    More stuff
  */

  require('./creek-content');

  //Audio Part 1 (Set up shared objects.)
  require('./creek-audio-lib');

  //Audio Part 2 (Requires functions from creek-audio-lib.js)
  require('./creek-audio');

  //Audio Part 3 (Requires Creek.audio)
  require('./sm2-bar-ui-creek');

  //The Socket.io-based API interface that delivers /api/broadcasting and other events.
  var liveAPI = require('./creek-live-api').init();

  //Persistence Toolkits
  // These require Creek.audio and sm2_bar
  if(Creek.data.persist.enable){
    
    Creek.debug.log("Persistence: Checking.");

    if(!Creek.data.persist.type){
      Creek.debug.log("Creek: Since persistence is enabled, you must specify a persistence type.")
    }
    if(Creek.data.persist.type == "iframe"){
      Creek.debug.log("Persistence: Initializing: iframe");
      Creek.data.persist.instance = require('./creek-persist-iframe');
    }
    if(Creek.data.persist.type == "singlepage"){
      Creek.debug.log("Persistence: Initializing: singlepage");
      Creek.data.persist.instance = require('./creek-persist-singlepage');
    }

  }else{
    
    Creek.debug.log("Persistence: No.");
    Creek.data.persist.instance = null;
  
  }

  //Share functions for social media.
  Creek.share = require('./creek-share');

  //Return main Creek object.
  // !!! Should this be a "new" Creek object, built by constructor?
  return Creek;

}


// WEBPACK FOOTER //
// ./src/creek-build.js